import * as angular from "angular";
import { Effort } from "../../models/effort.model";
import { ResultDataProvider } from "../../data-provider/result.dp";
import { FieldDataProvider } from "../../data-provider/field.dp";
import { DashboardWidget } from "../../models/dashboard-widget.model";
import { CanvassStatus } from "../../models/canvass-status.model";
import { DashboardWidgetFilter } from "../../models/dashboard-widget-filter.model";
import { DashboardDataProvider } from "../../data-provider/dashboard.dp";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";
import * as _ from "lodash";

let DataTableComponent = {
    selector: "vcDataTable",
    templateUrl: "/angular/components/result/data-table.component.html",
    bindings: {
        widget: "=",
        filter: "=",
        mode: "=?",
    },
    controller: class DataTableController {
        // * bindings for typescript compiler *
        public widget: DashboardWidget;
        public filter: DashboardWidgetFilter;
        public mode: string;
        // ************************************

        public daysData: any[];
        public usersData: any[];
        public selectedRow: any;
        public firstLoadComplete: boolean = false;
        public loading: boolean = true;
        public orderLoading: boolean = false;
        public viewMode: string;
        public isLeaderView: boolean = true;
        public labels: any;
        public canvassStatuses: CanvassStatus[];
        public data: any[];
        public topLevelData: any[];
        public dataProvider: ResultDataProvider;
        public fieldDataProvider: FieldDataProvider;
        public dashboardDataProvider: DashboardDataProvider;
        public permissionProvider: PermissionCheck;
        public effort: Effort;
        public options: any;
        public lastLoadSize: number = 10;
        public columns: any;
        public titleColumn: string;
        public initializing: boolean = true;
        private $filter: any;
        private dialog: DialogUtils;
        private readonly $scope: any;

        constructor(
            $scope: any,
            $filter: any,
            __env: any,
            ResultDataProvider: ResultDataProvider,
            FieldDataProvider: FieldDataProvider,
            DashboardDataProvider: DashboardDataProvider,
            PermissionCheck: PermissionCheck,
            __app_type: string,
            DialogUtils: DialogUtils
        ) {
            this.$scope = $scope;
            this.$filter = $filter;
            this.dataProvider = ResultDataProvider;
            this.fieldDataProvider = FieldDataProvider;
            this.dashboardDataProvider = DashboardDataProvider;
            this.isLeaderView = __app_type == "LEADER";
            this.permissionProvider = PermissionCheck;
            this.viewMode = "items";
            this.dialog = DialogUtils;

            $scope.$watch(
                () => this.widget,
                (
                    newValue: DashboardWidget,
                    oldValue: DashboardWidget
                ): void => {
                    if (oldValue && newValue !== oldValue) {
                        if (
                            !this.initializing &&
                            this.dashboardDataProvider.widgetChangeRequiresReload(
                                newValue,
                                oldValue
                            )
                        ) {
                            if (
                                JSON.stringify(newValue.style.tableOptions) !=
                                JSON.stringify(oldValue.style.tableOptions)
                            ) {
                                if (this.widget.id) {
                                    this.dashboardDataProvider.updateWidget(
                                        this.widget
                                    );
                                }
                            }
                            this.loadData();
                        }

                        if (
                            JSON.stringify(newValue.style.tableType) !=
                            JSON.stringify(oldValue.style.tableType)
                        ) {
                            this.data = [];
                        }
                    }
                },
                true
            );

            $scope.$watch(
                () => this.filter,
                (
                    newValue: DashboardWidgetFilter,
                    oldValue: DashboardWidgetFilter
                ): void => {
                    if (
                        !this.initializing &&
                        oldValue &&
                        newValue !== oldValue &&
                        newValue.selected.length == oldValue.selected.length
                    ) {
                        this.loadData();
                    }
                },
                true
            );
        }

        $onInit(): void {
            if (!this.filter.order || typeof this.filter.order == "string") {
                this.filter.order = {
                    column: "title",
                    direction: "asc",
                };
                if (this.widget.filter) {
                    this.widget.filter.order = {
                        column: "title",
                        direction: "asc",
                    };
                }
                if (this.widget.id) {
                    if (
                        this.widget.style.tableType == "standard" &&
                        (!this.widget.style.tableOptions.columns ||
                            this.widget.style.tableOptions.columns.length == 0)
                    ) {
                        this.dashboardDataProvider
                            .getDataTableColumns()
                            .then((columns: any): void => {
                                this.widget.style.tableOptions.columns =
                                    columns[this.widget.datatype];
                                this.dashboardDataProvider.updateWidget(
                                    this.widget
                                );
                            });
                    } else {
                        this.dashboardDataProvider.updateWidget(this.widget);
                    }
                }
            }
            if (this.widget.datatype == "fields") {
                this.updateFieldOptions(this.widget.columnsField, "columns");
                if (this.widget.rowsField) {
                    this.updateFieldOptions(this.widget.rowsField, "rows");
                }
            }
            this.initializing = false;
            this.loadData();
        }

        updateFieldOptions(field: string, targetKey: string): void {
            if (!field) return;

            if (field.indexOf("customfield-") > -1 || field == "party") {
                this.fieldDataProvider
                    .getFieldValues(field)
                    .then((data: any): void => {
                        let columns = [];
                        angular.forEach(data, (value: string) => {
                            columns.push({
                                id: value,
                                name: value,
                                tooltip: null,
                                selected: true,
                            });
                        });
                        this.updateTableOptions(columns, targetKey);
                        this.initializing = false;
                        this.loadData();
                    });
            } else {
                this.updateTableOptions(
                    angular.copy(
                        this.fieldDataProvider.fieldTableColumns[field]
                    ),
                    targetKey
                );
            }
        }

        updateTableOptions(fields, targetKey: string): void {
            this.widget.style.tableOptions[targetKey] = fields;
            if (targetKey === "columns") {
                this.widget.style.tableOptions.columns.push({
                    id: "total",
                    name: "Total",
                    tooltip: null,
                    selected: true,
                });
            }
        }

        setOrderBy(columnName: any): void {
            this.orderLoading = true;
            if (this.filter.order.column == columnName) {
                this.filter.order.direction =
                    this.filter.order.direction == "desc" ? "asc" : "desc";
            } else {
                this.filter.order.column = columnName;

                this.filter.order.direction =
                    columnName == "title" ? "asc" : "desc";
            }
            this.widget.filter.order = this.filter.order;
            if (this.widget.datatype == "fields") {
                let direction = this.filter.order.direction;
                this.data.sort((a, b) => {
                    if (a[columnName] < b[columnName]) {
                        return direction === "asc" ? -1 : 1;
                    }
                    if (a[columnName] > b[columnName]) {
                        return direction === "asc" ? 1 : -1;
                    }
                    return 0;
                });
                this.orderLoading = false;
            } else if (this.widget.id) {
                this.dashboardDataProvider.updateWidget(this.widget);
            }
        }

        removeTrackingColumnsIfDisabled(): void {
            this.permissionProvider.getFeaturePermissions().then(() => {
                if (
                    !this.permissionProvider.hasPermission(
                        "CANVASSER_TRACKING_ALLOWED"
                    )
                ) {
                    this.widget.filter.selected =
                        this.widget.filter.selected.filter(function (item) {
                            return (
                                item !== "green_gps" &&
                                item !== "orange_gps" &&
                                item !== "red_gps" &&
                                item !== "grey_gps"
                            );
                        });
                }
            });
        }

        isDisabledLeaderColumn(column: any): boolean {
            return column.id.includes("gps");
        }

        expandRow(row: any): void {
            if (row.users) {
                this.viewMode = "users";
                this.selectedRow = row;
                this.usersData = row.users;
            } else {
                if (this.widget.datatype == "fields") {
                    return;
                }
                if (this.viewMode == "days") {
                    this.collapseRow();
                } else {
                    this.viewMode = "days";
                    this.selectedRow = row;

                    if (row.days) {
                        this.daysData = row.days;
                    } else {
                        this.dataProvider
                            .expandRow(row.id, this.widget, this.filter)
                            .then(
                                (data: any) => {
                                    row.days = data;
                                    this.daysData = data;
                                },
                                () => {
                                    row.loading = false;
                                }
                            );
                    }
                }
            }
        }

        collapseRow(): void {
            if (this.usersData && this.viewMode == "days") {
                this.viewMode = "users";
            } else {
                this.viewMode = "items";
                this.selectedRow = null;
                this.daysData = null;
            }
        }

        openItem(row: any, ev: any): void {
            ev.stopPropagation();
            if (this.isLeaderView && this.widget.datatype == "users") {
                this.dialog.show({
                    component: "vc-view-organisation-user",
                    targetEvent: ev,
                    size: "large",
                    scope: this.$scope,
                    ariaLabel: "View Person",
                    locals: {
                        selectedUser: null,
                        selectedUserId: row.id,
                        editable: true,
                        onUserDeleted: null,
                        onUserUpdated: null,
                    },
                });
            }
        }

        getColumnName(item: any): string {
            let name: string = "";
            if (this.widget && this.widget.datatype) {
                let dataTypeColumns = this.columns[this.widget.datatype];
                angular.forEach(dataTypeColumns, (column) => {
                    if (column.value == item) {
                        name = column.name;
                    }
                });
            }

            return name;
        }

        getColumnTooltip(item: any): string {
            let tooltip: string = null;
            if (this.widget && this.widget.datatype) {
                angular.forEach(
                    this.columns[this.widget.datatype],
                    (column) => {
                        if (column.value == item) {
                            tooltip = column.tooltip;
                        }
                    }
                );
            }

            return tooltip;
        }

        linkAddress(row: any): string {
            if (this.isLeaderView) return "";
            if (this.widget.datatype == "lists") {
                return (
                    "/#/people?origin=dashboards&group=" +
                    JSON.stringify({ gid: row.id, gname: row.title })
                );
            } else if (this.widget.datatype == "teams") {
                return "/#/teams/scoreboard/" + row.id;
            } else if (this.widget.datatype == "users") {
                return "/#/user/" + row.id;
            } else if (this.widget.datatype == "streets") {
                return (
                    "/#/houses?origin=dashboards&street=" +
                    JSON.stringify({
                        street: row.haddress,
                        city: row.hcity,
                        state: row.hstate,
                    })
                );
            }
        }

        getPivotTableValue(value: number, total: number): string {
            if (
                this.widget.style &&
                this.widget.style.tableOptions &&
                this.widget.style.tableOptions.figures &&
                this.widget.style.tableOptions.figures == "percent"
            ) {
                return ((value / total) * 100).toFixed(1) + "%";
            } else {
                return this.$filter("number")(value);
            }
        }

        loadData(): void {
            if (!this.initializing) {
                this.loading = true;
                this.collapseRow();

                if (this.widget.datatype == "fields") {
                    this.loadPivotData();
                    return;
                }
                if (
                    !this.widget.style.tableOptions.columns ||
                    this.widget.style.tableOptions.columns.length == 0
                ) {
                    this.dashboardDataProvider
                        .getDataTableColumns()
                        .then((columns: any): void => {
                            this.widget.style.tableOptions.columns =
                                columns[this.widget.datatype];
                            this.getTableData();
                        });
                } else {
                    this.getTableData();
                }
            }
        }
        getTableData(): void {
            this.dataProvider.tableData(this.widget, this.filter).then(
                (data: any) => {
                    this.data = data;
                    this.topLevelData = data;
                    this.lastLoadSize = this.data.length;
                    if (this.lastLoadSize == 1) {
                        this.expandRow(this.data[0]);
                    }
                    this.removeTrackingColumnsIfDisabled();
                    this.firstLoadComplete = true;
                    this.loading = false;
                    this.orderLoading = false;
                },
                (error) => {
                    this.data = null;
                    this.firstLoadComplete = true;
                    this.loading = false;
                    this.orderLoading = false;
                }
            );
        }

        loadPivotData(): void {
            if (!this.widget.columnsField || !this.widget.rowsField) {
                this.loading = false;
                this.orderLoading = false;
                return;
            }
            var emptyData = [];
            if (this.widget.style.tableOptions.rows.length > 0) {
                emptyData = this.widget.style.tableOptions.rows.map(
                    ({ name }: any): any => {
                        return { title: name, total: 0 };
                    }
                );
            }
            this.dataProvider
                .pivotTableData(this.widget, angular.copy(this.filter))
                .then(
                    (data: any) => {
                        this.data = _.values(
                            _.merge(
                                {},
                                _.keyBy(emptyData, "title"),
                                _.keyBy(data.data, "title")
                            )
                        );
                        this.titleColumn = data["tableColumn"];
                        this.topLevelData = data.data;
                        this.lastLoadSize = this.data.length;
                        this.removeTrackingColumnsIfDisabled();
                        this.firstLoadComplete = true;
                        this.loading = false;
                        this.orderLoading = false;
                    },
                    (error) => {
                        this.data = null;
                        this.firstLoadComplete = true;
                        this.loading = false;
                        this.orderLoading = false;
                    }
                );
        }
    },
};

angular
    .module("result")
    .component(DataTableComponent.selector, DataTableComponent);
